import { Link } from "react-router-dom";
import { Instagram, Facebook, Share2 } from "lucide-react";

const footerLinks = {
  company: [
    { name: "About Aarsa", href: "/about" },
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Terms & Conditions", href: "/terms" },
  ],
  customer: [
    { name: "Offer Details", href: "/offers" },
    { name: "Shipping and Delivery", href: "/shipping" },
    { name: "Packaging", href: "/packaging" },
    { name: "Returns & Cancellations", href: "/returns" },
  ],
  support: [
    { name: "24 Hour Priority Delivery T&C", href: "/express-delivery" },
    { name: "Contact Us", href: "/contact" },
    { name: "FAQ", href: "/faq" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-gray-100 text-gray-700">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <h3 className="text-2xl font-bold font-playfair text-gray-900 mb-4">
              Aarsa
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Each piece is carefully crafted to celebrate your unique style,
              whether it's for a special occasion or everyday moments.
              Discover collections that blend traditional artistry with
              contemporary designs, made to make you feel extraordinary.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-white hover:bg-gray-200 transition-colors shadow-sm"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-gray-700" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-white hover:bg-gray-200 transition-colors shadow-sm"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-gray-700" />
              </a>
              <a
                href="https://pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-white hover:bg-gray-200 transition-colors shadow-sm"
                aria-label="Pinterest"
              >
                <Share2 className="w-5 h-5 text-gray-700" />
              </a>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Customer Service</h4>
            <ul className="space-y-2 text-sm">
              {footerLinks.customer.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              {footerLinks.support.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-8 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} Aarsa - Product of Zestaura Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
